import React from 'react';

import { Text } from '@chakra-ui/react';

export default function GrayText({ children, ...rest }) {
  return (
    <Text
      color="gray.700"
      variant="largeBold"
      {...rest}>{children}
    </Text>
  );
}
